const LEAK_RE = /CHAT-\d|dataset\s+CHAT|VB\s*graduaci|\bpasada\s*\d/i;

export function textHasInternalLeak(text: string | null | undefined): boolean {
    return LEAK_RE.test(String(text || ''));
}

export function patchHasInternalLeak(values: Array<string | null | undefined>): boolean {
    return values.some((v) => textHasInternalLeak(v));
}

/** Proveedor tal como lo devuelve admin_list_catalog_suppliers. */
export interface SupplierMentionSource {
    slug?: string;
    name?: string;
    showBrand?: boolean;
    orderContactEmail?: string | null;
    feedConfig?: unknown;
}

/** Misma regla que merchandising.catalog_supplier_mention (servidor). */
export interface SupplierMentionTerms {
    names: string[];
    domains: string[];
    emails: string[];
}

function escapeRegExp(s: string): string {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function domainsFromFeedConfig(feedConfig: unknown): string[] {
    if (!feedConfig || typeof feedConfig !== 'object' || Array.isArray(feedConfig)) return [];
    const out = new Set<string>();
    for (const value of Object.values(feedConfig as Record<string, unknown>)) {
        if (typeof value !== 'string') continue;
        const m = /https?:\/\/([^/\s]+)/i.exec(value);
        if (!m) continue;
        const host = m[1].toLowerCase().replace(/^www\./, '');
        if (host) out.add(host);
    }
    return [...out];
}

/** Solo proveedores ocultos (show_brand = false): la marca pública (p. ej. JLC) nunca se marca. */
export function buildSupplierMentionTerms(suppliers: SupplierMentionSource[]): SupplierMentionTerms {
    const names = new Set<string>();
    const domains = new Set<string>();
    const emails = new Set<string>();
    for (const s of suppliers) {
        if (s.showBrand) continue;
        for (const n of [s.name, s.slug]) {
            const t = (n || '').trim();
            if (t.length >= 3) names.add(t);
        }
        const email = (s.orderContactEmail || '').trim().toLowerCase();
        if (email) emails.add(email);
        for (const d of domainsFromFeedConfig(s.feedConfig)) domains.add(d);
    }
    return { names: [...names], domains: [...domains], emails: [...emails] };
}

/** Devuelve el término detectado (email, dominio o nombre) o null. */
export function findSupplierMention(
    values: Array<string | null | undefined>,
    terms: SupplierMentionTerms,
): string | null {
    const text = values.map((v) => String(v || '')).join('\n');
    if (!text.trim()) return null;
    const lower = text.toLowerCase();
    for (const email of terms.emails) {
        if (lower.includes(email)) return email;
    }
    for (const domain of terms.domains) {
        if (lower.includes(domain)) return domain;
    }
    for (const name of terms.names) {
        const re = new RegExp(`(^|[^\\p{L}\\p{N}_])${escapeRegExp(name)}(?=$|[^\\p{L}\\p{N}_])`, 'iu');
        if (re.test(text)) return name;
    }
    return null;
}
